/*
  bz-nav-current: hash-aware reconciliation of the "you're here" marker on
  Shopify-rendered nav links.

  Shopify's link.active / link.current are evaluated server-side off request.path,
  which never carries the URL fragment. So a menu where two siblings point at the
  same collection — one bare (/collections/habitats-and-supplies, "Habitats &
  SuppliezS"), one anchored (#build-a-habitat-zone, "Build a Habitat Zone") —
  always crowns the bare one, even when the actual visit is the hash one.

  When the current URL has a hash AND a nav anchor matches that exact pathname +
  hash, promote it (aria-current="page", menu-list__link--active) and demote the
  bare-path sibling. Scoped to header-component and <nav> so unrelated in-page
  anchors stay untouched.
*/
(function () {
  function reconcile() {
    var herePath = window.location.pathname;
    var hereHash = window.location.hash;

    var anchors = document.querySelectorAll('header-component a[href], nav a[href]');
    if (!anchors.length) return;

    var pathMatches = [];
    for (var i = 0; i < anchors.length; i++) {
      var a = anchors[i];
      var url;
      try {
        url = new URL(a.getAttribute('href'), window.location.href);
      } catch (e) {
        continue;
      }
      if (url.pathname !== herePath) continue;
      pathMatches.push({ a: a, hash: url.hash });
    }
    if (!pathMatches.length) return;

    // If there's no exact hash match in this nav scope, leave Shopify's default
    // markup alone — the bare-path "current" is the best signal we have.
    var winners;
    if (hereHash) {
      winners = pathMatches.filter(function (m) { return m.hash === hereHash; });
      if (!winners.length) return;
    } else {
      winners = pathMatches.filter(function (m) { return m.hash === ''; });
    }

    var winnerSet = new Set(winners.map(function (m) { return m.a; }));

    for (var j = 0; j < pathMatches.length; j++) {
      var link = pathMatches[j].a;
      var isWinner = winnerSet.has(link);
      if (isWinner) {
        link.setAttribute('aria-current', 'page');
        if (link.classList.contains('menu-list__link')) {
          link.classList.add('menu-list__link--active');
        }
      } else {
        if (link.getAttribute('aria-current') === 'page') {
          link.removeAttribute('aria-current');
        }
        link.classList.remove('menu-list__link--active', 'menu-drawer__menu-item--active');
      }
    }
  }

  if (document.readyState !== 'loading') {
    reconcile();
  } else {
    document.addEventListener('DOMContentLoaded', reconcile);
  }
  window.addEventListener('hashchange', reconcile);
})();
